<p class="agent-campaign-summary-list-item__title">{{title}} <ng-content select="[agCampaignsActions]"></ng-content>:</p>

<div class="agent-campaign-summary-list-item__content">
  <ng-content></ng-content>
</div>
